import PropTypes from 'prop-types'

const StylishHatAndTails = ({cobranding}) => {
  if (!cobranding.enabled) {
    return (
      <style>
        {`
          .wrapper {
            min-height: 100%;
            margin: 0 auto -100px;
          }
          
          .push { height: 100px; }
        `}
      </style>
    )
  }
  return null
}

StylishHatAndTails.propTypes = {
  cobranding: PropTypes.shape({
    enabled: PropTypes.bool.isRequired
  }).isRequired
}

export default StylishHatAndTails

